import { BreadType } from 'types/bread'
import { useEffect, useState } from 'react'
import { db } from 'firebase/index'

const fetchBread = (id: string): Promise<BreadType> => {
  return db
    .collection('breads')
    .doc(id)
    .get()
    .then((snapshot) => {
      const data = snapshot.data() as BreadType
      data.bread_ref = snapshot.ref
      return data
    })
}

const useQueryBreads = (breadIds: string[]): BreadType[] => {
  const [breads, setBreads] = useState<BreadType[]>([])

  // 商品が追加されたら商品情報を取得
  useEffect(() => {
    ;(async () => {
      if (breadIds.length === 0) {
        setBreads([])
      } else {
        const promises = breadIds.map((id) => fetchBread(id))
        try {
          const nextBreads = await Promise.all(promises)
          setBreads([...nextBreads])
        } catch (e) {
          console.error(e)
        }
      }
    })()
  }, [breadIds])

  return breads
}

export default useQueryBreads
